export default function ArrowUpRight({ className = "" }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.75 16.25L16.25 3.75M16.25 3.75L6.875 3.75M16.25 3.75V13.125"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="bevel"
      />
    </svg>
  );
}
